<template>
  <div class="a5">
    <div class="KFatura aski" v-for="f in FaturaDokum">
      <div class="KFaturaIc">
        <div class="KHeader text-center">
          <el-row :gutter="24">
            <el-col :span="8" class="text-left">
              <LazerHeaderLogo v-if="Hesap_id==6"></LazerHeaderLogo>
              <img v-if="Hesap_id!=6" :src="Logo" width="50%">
            </el-col>
            <el-col :span="8">
              <div>
                <h6><b>{{ f.AdSoyad }}</b></h6>
                <h6><b>Abone No:{{ f.AboneNo }}</b></h6>
                <small style="display:block">No: {{ f.kNo }} / {{ f.m2 }} <sup>m2</sup></small>
                <h6><b>{{ Fatura.BinaAdi }}</b> <br>{{ Fatura.aciklama }} <b>Isınma Gider Paylaşımı</b></h6>
              </div>
            </el-col>
            <el-col :span="8">
              <div class=" text-right">
                    <span class="h4">
                      <small style="font-weight: bold;font-size: 12px">ÖDENECEK TUTAR </small><br>
                      <b>{{ f.Odenecek }}<sup>TL</sup></b>
                    </span><br>
                <span class="h6">
                      <small style="font-weight: bold;font-size: 12px">SON ÖDEME TARİHİ</small><br>
                      <b>{{ Fatura.starih }}</b>
                    </span>
                <div class="clearfix"></div>
              </div>
            </el-col>
          </el-row>
          <hr>
          <el-row :gutter="24">
            <el-col :span="24">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th :colspan="Fatura.eAciklama?10:9" class="text-center">FATURA/DÖNEM BİLGİLERİ</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <small class="d-block">Son Ödeme Tarihi</small>
                    <b style="font-size: 12px">{{ Fatura.starih }}</b>
                  </td>
                  <td>
                    <small class="d-block">Fatura Tarihi</small>
                    <b style="font-size: 12px">{{ Fatura.ftarih }}</b>
                  </td>
                  <td class="text-right">
                    <small class="d-block">Hesaplanan Enerji</small>
                    <b style="font-size: 12px">{{ AltToplam.Hesap }} <sup>kWh</sup></b>
                  </td>
                  <td class="text-right">
                    <small class="d-block">Hesaplanan Enerji Birim</small>
                    <b style="font-size: 12px">{{ AltToplam.Birim }} <sup>TL</sup></b>
                  </td>
                  <td class="text-right">
                    <small class="d-block">Toplam Kapalı Alan</small>
                    <b style="font-size: 12px">{{ AltToplam.KapaliAlan }}<sup>m2</sup></b>
                  </td>
                  <td class="text-right" v-if="Fatura.SicakSu">
                    <small class="d-block">Şebeke Suyu</small>
                    <b style="font-size: 12px">{{ Fatura.SuBirim }}<sup>TL</sup></b>
                  </td>
                  <td class="text-right" v-if="Fatura.SicakSu">
                    <small class="d-block">Şebeke Suyu Isıtma</small>
                    <b style="font-size: 12px">{{ AltToplam.sTuketim }}<sup>TL</sup></b>
                  </td>

                  <td class="text-right" v-if="Fatura.eAciklama">
                    <small class="d-block">{{ Fatura.eAciklama }}</small>
                    <b style="font-size: 12px"> {{ Fatura.eTutar }}<sup>TL</sup></b>
                  </td>
                  <td class="text-right" v-if="Fatura.Tur==1">
                    <small class="d-block">Ortak Alan</small>
                    <b style="font-size: 12px"><sup>%{{ Fatura.oAlan }}</sup> {{ AltToplam.oAlan }}<sup>TL</sup></b>
                  </td>
                  <td class="text-right" v-if="Fatura.Tur==2">
                    <small class="d-block">Su Ortak Alan</small>
                    <b style="font-size: 12px"><sup>%{{ Fatura.oAlan }}</sup> {{ AltToplam.SuOrtak }}<sup>TL</sup></b>
                  </td>
                  <td class="text-right">
                    <small class="d-block">Fatura Tutarı</small>
                    <b style="font-size: 12px">{{ Fatura.tutar }}<sup>TL</sup></b>
                  </td>
                </tr>
                </tbody>
              </table>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <div class="clearfix"></div>
            <el-col :span="12">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th colspan="2" class="text-center">GİDER DETAYLARI</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="Fatura.Tur==1">
                  <td :rowspan="Fatura.MuafPay?4:3" width="20"><b>ISINMA GİDERLERİ</b></td>
                  <td><span>TÜKETİM BEDELİ</span><b class="float-right">{{ f.tUcret }}<sup>TL</sup></b></td>
                </tr>
                <tr v-if="Fatura.Tur==1">
                  <td><span>ORTAK ALAN BEDELİ</span><b class="float-right">{{ f.oAlan }}<sup>TL</sup></b></td>
                </tr>
                <tr v-if="Fatura.MuafPay">
                  <td><span>MUAF MESKEN PAYI</span><b class="float-right">{{ f.MuafUcret }}<sup>TL</sup></b></td>
                </tr>
                <tr v-if="Fatura.Tur==1">
                  <td><span>15°C MANİPÜLASYON</span><b class="float-right">{{ f.iFark }}<sup>kWh</sup></b></td>
                </tr>
                <tr v-if="Fatura.SicakSu">
                  <td rowspan="3" width="20"><b>SICAK SU GİDERLERİ</b></td>
                  <td><span>TÜKETİM BEDELİ</span><b class="float-right">{{ f.sTuketim }}<sup>TL</sup></b></td>
                </tr>
                <tr v-if="Fatura.SicakSu">
                  <td><span>ORTAK TÜKETİM BEDELİ</span><b class="float-right">{{ f.SuOrtak }}<sup>TL</sup></b></td>
                </tr>
                <tr v-if="Fatura.SicakSu">
                  <td><span>ŞEBEKE BEDELİ</span><b class="float-right">{{ f.sSebeke }}<sup>TL</sup></b></td>
                </tr>
                <tr>
                  <td colspan="2"><span>OKUMA ÜCRETİ</span><b class="float-right">{{ f.Okuma }}<sup>TL</sup></b>
                  </td>
                </tr>
                <tr v-if="Fatura.eAciklama">
                  <td colspan="2"><span>{{ Fatura.eAciklama }}</span><b
                    class="float-right">{{ f.eTutar }}<sup>TL</sup></b></td>
                </tr>
                <tr>
                  <td colspan="2"><span>ALT TOPLAM</span><b class="float-right">{{ f.Odenecek }}<sup>TL</sup></b>
                  </td>
                </tr>
                </tbody>
              </table>
            </el-col>
            <el-col :span="12">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th colspan="5" class="text-center" v-if="!Fatura.PayOlcer">SAYAÇ VE ENDEKS DETAYLARI</th>
                  <th colspan="5" class="text-center" v-if="Fatura.PayOlcer">ODA VE PETEK DETAYLARI</th>
                </tr>
                <tr>
                  <th>SAYAÇ NO</th>
                  <th>{{ Fatura.PayOlcer ? 'ODA' : 'TÜR' }}</th>
                  <th v-if="!Fatura.PayOlcer" class="text-right">İLK</th>
                  <th v-if="!Fatura.PayOlcer" class="text-right">SON</th>
                  <th class="text-right">FARK</th>
                  <th v-if="Fatura.PayOlcer" class="text-right">ÇARPAN</th>
                  <th v-if="Fatura.PayOlcer" class="text-right">HESAP FARK</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="s in f.Sayac">
                  <td>{{ s.SayacNo }}</td>
                  <td>{{ s.Tur }}</td>
                  <td v-if="!Fatura.PayOlcer" class="text-right">{{ s.Ilk }}<sup>{{ s.Birim }}</sup></td>
                  <td v-if="!Fatura.PayOlcer" class="text-right">{{ s.Son }}<sup>{{ s.Birim }}</sup></td>
                  <td class="text-right">{{ s.Fark }}<sup>{{ s.Birim }}</sup></td>
                  <td class="text-right" v-if="Fatura.PayOlcer">{{ s.Carpan }}</td>
                  <td  class="text-right" v-if="Fatura.PayOlcer">{{ s.hFark }}<sup>{{ s.Birim }}</sup></td>
                </tr>
                </tbody>
              </table>
            </el-col>
          </el-row>
          <el-row :gutter="24">

            <el-col :span="24">
              <p class="text-left" v-if="f.Uyari">
                {{ f.Uyari }}
              </p>
              <p class="text-left" v-if="f.Mahsup>0">
                {{ f.Mahsup }}kWh MAHSUPLAŞILMIŞTIR
              </p>
              <p class="text-left" v-if="Fatura.dAciklama">
                <b>AÇIKLAMA :</b> {{ Fatura.dAciklama }}
              </p>
              <hr>
              <p style="font-size: 10px;">Bu belge ve hesaplaması 14 Nisan 2008 tarihli resmi gazetede
                yayınlanan 26847
                sayılı
                "Merkez Isınma ve Sıhhi
                Sıcak Su Sistemlerinde Merkez Isınma ve Sıhhi Sıcak Su Giderlerinin Paylaştırılmasına İlişkin
                Yönetmelik"
                esaslarına göre düzenlenmiştir.</p>
              <p style="font-size: 10px;" v-if="Hesap_id==6">
                BU DÖKÜMAN 6698 SAYILI KİŞİSEL VERİLERİN KORUNMA KANUNU KAPSAMINDA 3.KİŞİLERLE PAYLAŞILMAYACAKTIR.<br>
                YAPIFEN ENERJİNİN 3. KİŞİLERLE PAYLAŞIMDAN DOĞACAK HİÇBİR HUKUKİ, CEZA-İ VE İDARİ SORUMLULUĞU YOKTUR.
              </p>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="sayfasonu"></div>
    </div>
  </div>
</template>


<script>
import LazerReklam from "./LazerReklam";
import LazerHeaderLogo from "./LazerHeaderLogo";

export default {
  components: {LazerHeaderLogo, LazerReklam},
  props: ['FaturaDokum', 'Fatura', 'AltToplam', 'Hesap_id','Logo']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/Sayaca5.vue